import { create } from 'zustand';
import type { BusinessClient } from '@/shared/types/database.types';

interface BusinessState {
  selectedBusiness: BusinessClient | null;

  setSelectedBusiness: (business: BusinessClient | null) => void;
  clearForOrgSwitch: () => void;
}

export const useBusinessStore = create<BusinessState>((set) => ({
  selectedBusiness: null,

  setSelectedBusiness: (business) => set({ selectedBusiness: business }),
  clearForOrgSwitch: () => set({ selectedBusiness: null }),
}));
